<template>
  <div class="about" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="home_main_box">
      <div class="site_width">
        <div class="Practices_title">
            <h1>金展荣誉</h1>
        </div>
        <div class="padding15"> 
          <div class="honor_info"> 
            <div class="news_content" v-html="columnContent.content"></div>
            <p><span></span><br /></p> 
          </div> 
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "honors",
    data() {
      return {
        pageParams: {
          columnId: 10,
          state: 0,
          pageNo: 1,
          pageSize: 1
        },
        routeParams: {
          columnId: 10,
          columnName: '金展荣誉',
          parentId: 1
        },
        columnContent: {
          content: ''
        }
      }
    },
    mounted() {
      this.getPageList()
    },
    methods: {
      getPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_PAGE_API_URL, 'Json', this.pageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            if (res.data.data.total > 0) {
              this.columnContent = res.data.data.list[0]
            }
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      }
    }
  }
</script>

<style lang="less">
  .news_content p {text-indent:2em}
</style>